import template from './email-design.template.html';
import {EmailDesignController} from './email-design.controller';

export class EmailDesignService {

    constructor($log, $uibModal) {
        'ngInject';

        this.$log = $log;
        this.$uibModal = $uibModal;

    }

    open() {

        let modalInstance = this.$uibModal.open({
            templateUrl: template,
            controller: EmailDesignController,
            controllerAs: '$ctrl'
        });

        modalInstance.result.then(() => {

        }, () => {
            this.$log.info('Modal dismissed at: ' + new Date());
        });

    }

}



// WEBPACK FOOTER //
// ./src/js/components/email-design/email-design.service.js